module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-4-766eaba09fd14c876118c53a39283f06.webp";